/* eslint-disable max-lines */
// TODO:fix-sdk-eslint
// TODO:fix-sdk-eslint
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { SourceType } from "../../model/enums/SDKSourceType";
import { TokenGroup } from "../../model/groups/SDKTokenGroup";
import { Logger } from "../../model/support/SDKLogger";
import { sureOf } from "../../utils/CommonUtils";
import { DTJSONConverter, } from "./utilities/SDKDTJSONConverter";
import { DTJSONGroupBuilder } from "./utilities/SDKDTJSONGroupBuilder";
import { DTJSONParser } from "./utilities/SDKDTJSONParser";
import { DTPluginPreciseCopyStrategy, DTPluginThemeOverrideStrategy, isPreciseCopyEnabled, } from "./utilities/SDKDTMapLoader";
import { DTMapResolver } from "./utilities/SDKDTMapResolver";
import { DTThemeMerger } from "./utilities/SDKDTThemeMerger";
import { DTTokenGroupTreeMerger } from "./utilities/SDKDTTokenGroupTreeMerger";
import { DTTokenMerger } from "./utilities/SDKDTTokenMerger";
import pick from "lodash/pick";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Tool implementation
/** Design Tokens Plugin Manipulation Tool */
export class SupernovaToolsDesignTokensPlugin {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(designSystemId, versionId, instance, logger = new Logger()) {
        this.sortMultiplier = 100;
        this.designSystemId = designSystemId;
        this.versionId = versionId;
        this.instance = instance;
        this.logger = logger;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Primary synchronization
    async synchronizeTokensFromData(data, mapping, settings) {
        const { logs } = await this.synchronizeTokensFromDataWithResults(data, mapping, settings);
        return { result: true, logs };
    }
    async synchronizeTokensFromDataWithResults(data, mapping, settings) {
        const results = [];
        // Fetch brand and themes
        const brands = await this.instance.brands.getBrands({
            designSystemId: this.designSystemId,
            versionId: this.versionId,
        });
        const themes = await this.instance.tokens.getTokenThemes({
            designSystemId: this.designSystemId,
            versionId: this.versionId,
        });
        const sources = await this.instance.dataSources.getDataSources({
            designSystemId: this.designSystemId,
            versionId: this.versionId,
        });
        // Parse data from object
        const parser = new DTJSONParser(this.logger);
        const parsedData = parser.processPluginDataRepresentation(data);
        // Post process the data
        this.processTokenNodes(parsedData, mapping, brands, settings.verbose);
        for (const map of mapping) {
            // First, process default values for tokens, for each brand, separately, skipping themes as they need to be created later
            if (map.bindToTheme) {
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line no-continue
                continue;
            }
            // Find the destination brand
            const brand = brands.find((b) => b.id === map.bindToBrand ||
                map.bindToBrand.toLowerCase().trim() === b.name.toLowerCase().trim());
            if (!brand) {
                throw new Error(`Unknown brand ${map.bindToBrand}
           provided in binding.\n\nAvailable brands in this design system: [${brands.map((b) => `${b.name} (id: ${b.id})`)}]`);
            }
            this.setTokensOrigin(map, brand, sources);
            // TODO:fix-sdk-eslint
            // eslint-disable-next-line no-await-in-loop
            const mergeResult = await this.mergeWithRemoteSource(
            // @ts-expect-error TS(2345): Argument of type 'DTProcessedTokenNode<AnyToken>[]... Remove this comment to see the full error message
            map.processedNodes, brand, !settings.dryRun, settings.verbose, settings.preciseCopy);
            results.push({
                map: pick(map, [
                    "bindToBrand",
                    "bindToTheme",
                    "pluginSets",
                    "pluginTheme",
                    "type",
                ]),
                tokensCreated: mergeResult.diff.toCreate.map((t) => t.token.id),
                tokensUpdated: mergeResult.diff.toUpdate.map((t) => t.token.id),
                tokensDeleted: mergeResult.diff.toDelete.map((t) => t.token.id),
            });
            if (settings.verbose) {
                this.logger.log(`✅ (task done) Synchronized base tokens for brand ${brand.name}`);
            }
        }
        for (const map of mapping) {
            // Merge all remaining themes
            if (!map.bindToTheme) {
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line no-continue
                continue;
            }
            // Find the destination brand
            const brand = brands.find((b) => b.id === map.bindToBrand ||
                map.bindToBrand.toLowerCase().trim() === b.name.toLowerCase().trim());
            if (!brand) {
                throw new Error(`Unknown brand ${map.bindToBrand}
           provided in binding.\n\nAvailable brands in this design system: [${brands.map((b) => `${b.name} (id: ${b.id})`)}]`);
            }
            // Find the destination theme
            const matchedThemes = themes.filter((t) => t.brandId === brand.id &&
                (t.id === map.bindToTheme ||
                    // @ts-expect-error TS(2531): Object is possibly 'null'.
                    map.bindToTheme.toLowerCase().trim() ===
                        t.name.toLowerCase().trim() ||
                    // @ts-expect-error TS(2531): Object is possibly 'null'.
                    map.bindToTheme.toLowerCase().trim() ===
                        t.codeName.toLowerCase().trim()));
            if (matchedThemes.length > 1) {
                throw new Error(`Ambiguous theme ${map.bindToTheme}
           provided in binding.\n\nPlease, use unique name in mapping or rename theme name or code in Supernova.\n\nAvailable themes in this design system: ${brands.map((b) => 
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                `Brand: ${b.name} (id: ${b.id})\n${themes
                    .filter((th) => th.brandId === b.id)
                    .map((t) => `    Theme: ${t.name} (id: ${t.id})`)}`)}`);
            }
            const theme = matchedThemes[0];
            if (!theme) {
                throw new Error(`Unknown theme ${map.bindToTheme}
           provided in binding.\n\nAvailable themes in this design system: ${brands.map((b) => `Brand: ${b.name} (id: ${b.id})\n${themes
                    .filter((th) => th.brandId === b.id)
                    .map((t) => `    Theme: ${t.name} (id: ${t.id})`)}`)}`);
            }
            this.setTokensOrigin(map, brand, sources);
            // TODO:fix-sdk-eslint
            // eslint-disable-next-line no-await-in-loop
            const mergeResult = await this.mergeThemeWithRemoteSource(
            // @ts-expect-error TS(2345): Argument of type 'DTProcessedTokenNode<AnyToken>[]... Remove this comment to see the full error message
            map.processedNodes, brand, theme, !settings.dryRun, settings.verbose, settings.preciseCopy, settings.themeOverridesStrategy);
            results.push({
                map: pick(map, [
                    "bindToBrand",
                    "bindToTheme",
                    "pluginSets",
                    "pluginTheme",
                    "type",
                ]),
                tokensCreated: [],
                tokensUpdated: mergeResult.tokens.map((t) => t.id),
                tokensDeleted: [],
            });
            if (settings.verbose) {
                this.logger.log(`✅ (task done) Synchronized themed tokens for brand ${brand.name}, theme ${theme.name}`);
            }
        }
        // If preciseCopy = true we should remove all themes' overrides, that are not in source
        if (isPreciseCopyEnabled(settings.preciseCopy)) {
            const mapInSource = mapping
                .filter((m) => !!m.bindToTheme)
                .map((m) => ({
                brand: m.bindToBrand,
                // @ts-expect-error TS(2531): Object is possibly 'null'.
                theme: m.bindToTheme.toLowerCase().trim(),
            }));
            const themesInSource = mapInSource.map((m) => m.theme);
            const themesToRemove = themes.filter((t) => !(themesInSource.includes(t.id.toLowerCase().trim()) ||
                themesInSource.includes(t.name.toLowerCase().trim())));
            for (const themeToRemove of themesToRemove) {
                const brand = brands.find((b) => b.id === themeToRemove.brandId);
                const themeBrandInMapping = mapping.find((m) => 
                // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                m.bindToBrand === brand.id ||
                    m.bindToBrand.toLowerCase().trim() ===
                        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                        brand.name.toLowerCase().trim());
                if (!themeBrandInMapping) {
                    if (settings.verbose) {
                        this.logger.log(
                        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                        `✅ (task done) Skip remove themes' overrides for brand ${brand.name}, theme ${themeToRemove.name}`);
                    }
                    // TODO:fix-sdk-eslint
                    // eslint-disable-next-line no-continue
                    continue;
                }
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line no-await-in-loop
                await this.mergeThemeWithRemoteSource([], 
                // @ts-expect-error TS(2345): Argument of type 'Brand | undefined' is not assign... Remove this comment to see the full error message
                brand, themeToRemove, !settings.dryRun, settings.verbose, settings.preciseCopy, settings.themeOverridesStrategy);
                if (settings.verbose) {
                    this.logger.log(
                    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                    `✅ (task done) Removed themes' overrides for brand ${brand.name}, theme ${themeToRemove.name}`);
                }
            }
        }
        return { results, logs: this.logger.logs };
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Data processing
    processTokenNodes(parseResult, mapping, brands, verbose) {
        // Create base objects
        const mapResolver = new DTMapResolver();
        // Resolve each theme or set separately
        for (const map of mapping) {
            const resolvedMap = mapResolver.mappedNodePools(map, parseResult.themes, parseResult.sets);
            if (!resolvedMap.nodes) {
                throw new Error("Resolved map doesn't contain resulting nodes");
            }
        }
        let count = 0;
        for (const map of mapping) {
            count += 1;
            // Find appropriate brand
            const brand = brands.find((b) => b.id === map.bindToBrand ||
                map.bindToBrand.toLowerCase().trim() === b.name.toLowerCase().trim());
            if (!brand) {
                throw new Error(`Unknown brand ${map.bindToBrand}
           provided in binding. Available brands in this design system: \n\n ${brands.map((b) => `${b.name} (id: ${b.id})`)}`);
            }
            const converter = new DTJSONConverter(this.versionId, mapping);
            const groupBuilder = new DTJSONGroupBuilder(this.versionId, mapping);
            // @ts-expect-error TS(2345): Argument of type 'DTParsedNode[] | null' is not as... Remove this comment to see the full error message
            const processedNodes = converter.convertNodesToTokens(map.nodes, brand);
            const processedGroups = groupBuilder.constructAllDefinableGroupsTrees(processedNodes, brand);
            map.processedNodes = processedNodes;
            map.processedGroups = processedGroups;
            if (verbose) {
                this.logger.log(`\n----- Processing mapping entry #${count}:`);
                this.logger.log(`Processed nodes: ${processedNodes.length}`);
                this.logger.log(`Processed groups: ${processedGroups.length}`);
            }
        }
        return mapping;
    }
    setTokensOrigin(map, brand, sources) {
        var _a, _b, _c;
        const sourceId = (_a = sources.find((s) => s.type === SourceType.tokenStudio && s.brandId === brand.id)) === null || _a === void 0 ? void 0 : _a.id;
        if (!sourceId) {
            return map;
        }
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        for (const node of map.processedNodes) {
            node.token.origin = Object.assign(Object.assign({ name: [...node.path.slice(1), node.token.name].join("/"), sourceId, id: node.key }, (((_b = node.token.origin) === null || _b === void 0 ? void 0 : _b.referenceOriginId)
                ? { referenceOriginId: node.token.origin.referenceOriginId }
                : {})), (((_c = node.token.origin) === null || _c === void 0 ? void 0 : _c.referencePersistentId)
                ? { referencePersistentId: node.token.origin.referencePersistentId }
                : {}));
        }
        return map;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Validation
    /** Creates pure tree for validation purposes, ignoring any existing token state in workspaces. This method works offline. */
    createPureTokenTree(processedNodes, verbose) {
        // Fake remote token data
        const upstreamTokenGroups = new Array();
        const upstreamTokens = new Array();
        // Assign correct sorting order to incoming tokens and token groups
        this.correctSortOrder(upstreamTokens, upstreamTokenGroups);
        // Merge trees
        const pack = [
            ...upstreamTokens,
            ...upstreamTokenGroups,
        ];
        const treeMerger = new DTTokenGroupTreeMerger();
        const tokenMerger = new DTTokenMerger();
        const tokenMergeResult = tokenMerger.makeTokensDiff(upstreamTokens, processedNodes, upstreamTokenGroups);
        const result = treeMerger.makeGroupsDiff(tokenMergeResult, pack);
        // Update referenced tokens in group based on the result
        const groups = [];
        for (const item of result.toCreate) {
            if (item.element instanceof TokenGroup) {
                item.element.childrenIds = item.childrenIds;
                groups.push(item.element);
            }
        }
        for (const item of result.toUpdate) {
            if (item.element instanceof TokenGroup) {
                item.element.childrenIds = item.childrenIds;
                groups.push(item.element);
            }
        }
        // Prepare data for take synchronization
        const tokensToWrite = processedNodes.map((n) => n.token);
        const tokenGroupsToWrite = groups;
        // Log if needed
        if (verbose) {
            this.logger.log(`\n----- Token tree constructed: `);
            this.logger.log(`Token groups updated: ${tokenGroupsToWrite.length}`);
            this.logger.log(`Tokens created: ${tokenMergeResult.toCreate.length}`);
            this.logger.log(`\n`);
        }
        return {
            tokens: tokensToWrite,
            groups: tokenGroupsToWrite,
        };
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Merging
    /** Loads remote source connected to this tool, then merges tokens and groups with it, creating union. Can optionally write to the source as well */
    async mergeWithRemoteSource(processedNodes, brand, write, verbose, preciseCopy) {
        // Get remote token data and filter them by selected brand
        const upstreamAllTokens = (await this.instance.tokens.getTokens({
            designSystemId: this.designSystemId,
            versionId: this.versionId,
        }));
        const upstreamAllTokenGroups = await this.instance.tokens.getTokenGroups({
            designSystemId: this.designSystemId,
            versionId: this.versionId,
        });
        const upstreamTokenGroups = upstreamAllTokenGroups.filter((g) => g.brandId === brand.idInVersion || g.brandId === brand.id);
        const upstreamTokens = upstreamAllTokens.filter((g) => g.brandId === brand.idInVersion || g.brandId === brand.id);
        // Assign correct sorting order to incoming tokens and token groups
        this.correctSortOrder(upstreamTokens, upstreamTokenGroups);
        // Merge trees
        const pack = [
            ...upstreamTokens,
            ...upstreamTokenGroups,
        ];
        const treeMerger = new DTTokenGroupTreeMerger();
        const tokenMerger = new DTTokenMerger();
        const tokenMergeResult = tokenMerger.makeTokensDiff(upstreamTokens, processedNodes, upstreamTokenGroups);
        const result = treeMerger.makeGroupsDiff(tokenMergeResult, pack);
        // Update referenced tokens in group based on the result
        const groups = [];
        for (const item of result.toCreate) {
            if (item.element instanceof TokenGroup) {
                item.element.childrenIds = item.childrenIds;
                groups.push(item.element);
            }
        }
        for (const item of result.toUpdate) {
            if (item.element instanceof TokenGroup) {
                item.element.childrenIds = item.childrenIds;
                groups.push(item.element);
            }
        }
        // Synchronize changes if enabled
        const tokensToWrite = processedNodes.map((n) => n.token);
        const tokenGroupsToWrite = groups;
        // If precise copy is enabled, we'll delete the tokens that were not in the source,
        const shouldDeleteMissingTokens = preciseCopy === DTPluginPreciseCopyStrategy.deleteAll;
        if (write) {
            await this.instance.tokens.writeTokens({
                designSystemId: this.designSystemId,
                versionId: this.versionId,
            }, tokenMergeResult.toCreateOrUpdate.map((r) => r.token), tokenGroupsToWrite, shouldDeleteMissingTokens
                ? tokenMergeResult.toDelete.map((r) => r.token)
                : [], []);
        }
        if (verbose) {
            this.logger.log(`\n----- Base values synchronized: `);
            this.logger.log(`Token groups updated: ${tokenGroupsToWrite.length}`);
            this.logger.log(`Tokens created: ${tokenMergeResult.toCreate.length}`);
            this.logger.log(`Tokens updated: ${tokenMergeResult.toUpdate.length}`);
            this.logger.log(`Tokens deleted: ${shouldDeleteMissingTokens
                ? tokenMergeResult.toDelete.length
                : `Deletion disabled because preciseCopy: false`}`);
            if (!write) {
                this.logger.log(`Data were not written to workspace because dryRun was enabled`);
            }
            this.logger.log(`\n`);
        }
        return {
            tokens: tokensToWrite,
            groups: tokenGroupsToWrite,
            diff: tokenMergeResult,
        };
    }
    /** Loads remote source connected to this tool, then creates the diff from the base tree and updates the associated theme. Can optionally write to the source as well */
    async mergeThemeWithRemoteSource(processedNodes, brand, theme, write, verbose, preciseCopy = DTPluginPreciseCopyStrategy.none, themeOverridesStrategy = DTPluginThemeOverrideStrategy.default) {
        // Get remote token data and filter them by selected brand
        const upstreamAllTokens = await this.instance.tokens.getTokens({
            designSystemId: this.designSystemId,
            versionId: this.versionId,
        });
        // Get remote token group data and filter them by selected brand
        const upstreamTokenGroups = await this.instance.tokens.getTokenGroups({
            designSystemId: this.designSystemId,
            versionId: this.versionId,
        });
        const upstreamTokens = upstreamAllTokens.filter((g) => g.brandId === brand.id || g.brandId === brand.id);
        const upstreamTheme = theme;
        const themeMerger = new DTThemeMerger(this.versionId);
        const themeMergerResult = themeMerger.makeTheme(upstreamTokens, upstreamTokenGroups, upstreamTheme, processedNodes, preciseCopy, themeOverridesStrategy);
        if (write) {
            await this.instance.tokens.writeTheme({
                designSystemId: this.designSystemId,
                versionId: this.versionId,
            }, themeMergerResult);
        }
        if (verbose) {
            this.logger.log(`----- Theme values synchronized:`);
            this.logger.log(`Created or updated overrides: ${themeMergerResult.overriddenTokens.length}`);
            if (!write) {
                this.logger.log(`Data were not written to workspace because dryRun was enabled`);
            }
        }
        return {
            theme,
            tokens: themeMergerResult.overriddenTokens,
        };
    }
    correctSortOrder(tokens, tokenGroups) {
        // Build maps so lookup is faster
        const tokenMap = new Map();
        const groupMap = new Map();
        tokens.forEach((t) => tokenMap.set(t.id, t));
        tokenGroups.forEach((g) => groupMap.set(g.id, g));
        // Correct order for each root
        const roots = tokenGroups.filter((g) => g.isRoot);
        roots.forEach((r) => this.correctSortOrderFromTypeRoot(r, tokenMap, groupMap));
    }
    correctSortOrderFromTypeRoot(root, tokenMap, groupMap) {
        var _a;
        const ids = this.flattenedIdsFromRoot(root, tokenMap, groupMap);
        for (let i = 0; i < ids.length; i += 1) {
            const id = sureOf(ids[i]);
            const element = sureOf((_a = tokenMap.get(id)) !== null && _a !== void 0 ? _a : groupMap.get(id));
            element.sortOrder = i * this.sortMultiplier;
        }
    }
    flattenedIdsFromRoot(root, tokenMap, groupMap) {
        let result = [root.id];
        const ids = root.childrenIds;
        for (const id of ids) {
            result.push(id);
            const tokenGroup = groupMap.get(id);
            if (tokenGroup) {
                result = result.concat(this.flattenedIdsFromRoot(tokenGroup, tokenMap, groupMap));
            }
            else {
                const token = tokenMap.get(id);
                if (token) {
                    result.push(id);
                }
                else {
                    throw new Error(`Unable to find token or group ${id} of type ${root.tokenType}`);
                }
            }
        }
        return result;
    }
}
